// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__0GE96","empty":"styles_empty__yLomM"};